import moment from 'moment';
import { FinancialStatementPeriodFullWrite } from 'api/models/FinancialStatementPeriodFullWrite';
import { getArrayValue } from 'utilities';

export const isDateInPeriods = (
  date: string,
  periods: FinancialStatementPeriodFullWrite[],
  dateField: keyof FinancialStatementPeriodFullWrite,
  dateFormat: string
) => {
  const formattedDate = moment(date).format(dateFormat);
  const dates = getArrayValue(periods?.map(period => period?.[dateField]));
  return dates.includes(formattedDate);
};

export const isLastQuarter = (asOfDate: string, fyEnd: string) => {
  const date = moment(asOfDate, moment.ISO_8601, true);
  const fyEndMoment = moment(fyEnd, moment.ISO_8601, true);
  const fyEndStartMoment = fyEndMoment.clone().subtract(3, 'months');
  const dateIsWithinLastQuarter = date.isBetween(fyEndStartMoment, fyEndMoment, null, '[]');

  return dateIsWithinLastQuarter;
};
